module.exports = __webpack_public_path__ + "img/avatar_8.9dfb8878.jpg";